import React from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { useSelector } from "react-redux";
import { dashboardSelector } from "@/store/features/dashboardSlice";
import { GuardedLink } from "@/common/custom/GuardedLink";
import { useParams } from "react-router-dom";
import { employeeSelector } from "@/store/features/employeeSlice";
import { motion } from "framer-motion";

const OverrideBaseRoute: any = {
  "/home": "/dashboard",
};
const DISABLED_PATH = ["/home/employment-details"];

const BreadcrumbComponent: React.FC = () => {
  const { routeSegments } = useSelector(dashboardSelector);
  const { employeeInfo } = useSelector(employeeSelector);

  const { employeeId } = useParams();

  const generateBreadcrumbs = () => {
    return routeSegments.map((segment, index) => {
      const isEmployeeSegment = segment === employeeId && employeeInfo;
      const label = isEmployeeSegment ? employeeInfo?.empName?.label : segment;
  
      // Capitalize the first letter, replace hyphens with spaces, and capitalize the first letter of each word
      const formattedLabel = label
        .replace(/-/g, " ")  
        .split(' ') 
        .map((word:any) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');  // Join back the words
  
      return {
        label: formattedLabel,
        path: isEmployeeSegment ? null : "/" + routeSegments.slice(0, index + 1).join("/"),
      };
    });
  };

  const currentSegment = routeSegments?.[3] || "";
  const isEmployeeDetailsPage = ["overview", "exit", "activities", "employee-details", "attachments", "exit-details"].includes(currentSegment);
  let breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.some((t: any) => t.path === "/home/employees/action")) {
    breadcrumbs = breadcrumbs.slice(0, 2);
  }

  if (isEmployeeDetailsPage && !employeeInfo) {
    return (
      <motion.div
        key="breadcrumb-loader"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="inline-block h-4 w-[300px] mx-5 my-4 px-4 py-4 rounded bg-gray-200"
      />
    );
  }

  return (
    <Breadcrumb className="flex px-4 py-4 bg-containerBg text-text-default items-center">
      {breadcrumbs.map((crumb, index) => {
        const isDisabled = DISABLED_PATH.includes(crumb.path || "");
        return (
          <React.Fragment key={crumb.path || crumb.label}>
            {index > 0 && <span className="mx-1.5 text-10">/</span>}
            <BreadcrumbItem className={`text-10 !leading-normal font-normal !text-text-default`}>
              {!crumb.path || index === breadcrumbs.length - 1 ? (
                <BreadcrumbPage className={`!font-semibold !text-text-default`}>{crumb.label}</BreadcrumbPage>
              ) : isDisabled ? (
                <span>{crumb.label}</span>
              ) : (
                <BreadcrumbLink asChild>
                  <GuardedLink to={OverrideBaseRoute[crumb.path] ?? crumb.path}>{crumb.label}</GuardedLink>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        );
      })}
    </Breadcrumb>
  );
};

export default BreadcrumbComponent;
